import { render } from "./RegistrationUnavailable.vue?vue&type=template&id=5dce4f3c"
const script = {}

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__